goog.provide('el8.apphome.docMgr.ImageLoader');

goog.require('el8.apphome.docMgr.util');
goog.require('el8.service.intervals');

/**
 * ImageLoader
 * -----------
 * This module takes a set of images, loads/displays the first X images, and then
 * loads/displays images as they enter the scrollview
 */

el8.apphome.docMgr.ImageLoader = function(spec) {

    this._INITIAL_SIZE = spec.initialSize || 5;  // Number of images to display on first load
    this._imageWidth = spec.width;
    this._imageHeight = spec.height;
    this._imageClass = spec.imageClass || 'preview';

    this._imageWrapSelector = spec.imageWrapSelector || null;
    this._buttonSelector = spec.buttonSelector || null;

    this._container = spec.container;
    this._scrollContainer = spec.scrollContainer;

    this._selector = spec.selector;
    this._rendererFn = spec.rendererFn;
    this._itemIdFn = spec.itemIdFn;

    // NOTE!! Does not reflect display order
    this._items = [];

    var scrollTimeout = null;
    var that = this;
    this._scrollContainer.on('scroll', function() {
        if (scrollTimeout) {
            $.el8_clearTimeout(scrollTimeout);
        }
        scrollTimeout = $.el8_setTimeout(function() {
            that.loadImagesInView();
        }, 250);
    });
};
el8.apphome.docMgr.ImageLoader.prototype.show = function(items) {
    this._loadItems(items);
    for (var i=0; i<this._items.length; i++) {
        this._renderFrame(this._items[i]);
        if (i < this._INITIAL_SIZE && this._items[i].is('UploadedImage')) {
            this._loadImage(this._items[i].getId());
        }
    }
};
el8.apphome.docMgr.ImageLoader.prototype.reset = function() {
    this._items = [];
    this._container.empty();
};
el8.apphome.docMgr.ImageLoader.prototype.addItem = function(item, callbackFn) {
    this._items.push(item);
    this._renderFrame(item);
    if (this._items.length <= this._INITIAL_SIZE && item.is('UploadedImage')) {
        this._loadImage(item.getId(), callbackFn);
    } else {
        if (callbackFn) { callbackFn(); }
    }
};
el8.apphome.docMgr.ImageLoader.prototype.removeItem = function(itemId, callbackFn) {
    var that = this;
    var $elt = this._getRenderedItem(itemId);
    $elt.fadeOut(500, function() {
        $elt.remove();
        for (var i=0; i<that._items.length; i++) {
            if (that._items[i].getId() === itemId) {
                that._items.splice(i, 1);
            }
        }
        if (callbackFn) { callbackFn(); }
    });
};
el8.apphome.docMgr.ImageLoader.prototype.refreshImage = function(itemId) {
    var $elt = this._getRenderedItem(itemId);
    if ($('img', $elt).length) {
        el8.apphome.docMgr.util.refreshImage($('img', $elt), {
            imageWrapSelector: this._imageWrapSelector,
            width: this._imageWidth
        });
    }
};
el8.apphome.docMgr.ImageLoader.prototype.hasItems = function() {
    return !!this._items.length;
};
el8.apphome.docMgr.ImageLoader.prototype.getNthElt = function(n) {
    if (this._items.length > n) {
        return $(this._selector, this._container).eq(n);
    }
    return null;
};
el8.apphome.docMgr.ImageLoader.prototype.getItemIds = function() {
    var itemIds = [];
    $(this._selector, this._container).each(function(index, elt) {
        itemIds.push($(elt).attr('data-id')*1);
    });
    return itemIds;
};
el8.apphome.docMgr.ImageLoader.prototype.loadImagesInView = function() {

    var listTop = this._scrollContainer.offset().top;
    var listBottom = listTop + this._scrollContainer.height();

    var alreadySeen = false;
    var that = this;
    $(this._selector, this._container).each(function(index, elt) {
        if (el8.apphome.docMgr.util.isInView($(elt), listTop, listBottom)) {
            that._loadImage($(elt).attr('data-id')*1);
            alreadySeen = true;
        } else if (alreadySeen) {
            return false; // break out of loop
        }
    });
};
el8.apphome.docMgr.ImageLoader.prototype.hasItem = function(itemId) {
    return !!$(this._selector+'[data-id="'+itemId+'"]', this._container).length;
};
el8.apphome.docMgr.ImageLoader.prototype.readjustSizes = function(opts) {
    opts = opts || {};
    var $imageWraps, $buttons;
    if (this._imageWrapSelector) {
        $imageWraps = $(this._imageWrapSelector, this._container);
    }
    if (this._buttonSelector) {
        $buttons = $(this._buttonSelector, this._container);
    }
    if (opts.width) {
        this._imageWidth = opts.width;
        $("img", this._container).outerWidth(this._imageWidth);
        if ($imageWraps) { $imageWraps.outerWidth(this._imageWidth); }
        if ($buttons) { $buttons.outerWidth(this._imageWidth); }
    }
    if (opts.height) {
        this._imageHeight = opts.height;
        if ($imageWraps) { $imageWraps.height(this._imageHeight); }
    }
};


/**
 * Helper methods
 */
el8.apphome.docMgr.ImageLoader.prototype._getRenderedItem = function(itemId) {
    return $(this._selector+'[data-id="'+itemId+'"]', this._container);
};
el8.apphome.docMgr.ImageLoader.prototype._loadItems = function(items) {
    this._items = items;
    this._container.empty();
};
el8.apphome.docMgr.ImageLoader.prototype._renderFrame = function(item) {
    var $elt = $(this._rendererFn(item.getModelClass())(item, this._itemIdFn(item)));
    if (this._imageWrapSelector) {
        $(this._imageWrapSelector, $elt)
            .height(this._imageHeight)
            .outerWidth(this._imageWidth);
    }
    if (this._buttonSelector) {
        $(this._buttonSelector, $elt).outerWidth(this._imageWidth);
    }
    this._container.append($elt);
};
el8.apphome.docMgr.ImageLoader.prototype._loadImage = function(itemId, callbackFn) {
    var $elt = this._getRenderedItem(itemId);
    if (!$elt.find('img').length && $('.image-item', $elt).length) {
        el8.apphome.docMgr.util.loadImage($elt, {
            imageClass: this._imageClass,
            forceRefresh: false,
            width: this._imageWidth,
            imageWrapSelector: this._imageWrapSelector,
            successCb: callbackFn,
            errorCb: callbackFn
        });
    }
};
